import React, { useState, useEffect } from 'react';
import ProfileRow from './ProfileRow';
import CanvasItem from './avwapp.chart';
import { fetchData } from './service/avwapp.service';
import { host } from './env';





type MostActivesProps = {
    
  };

const MostActives: React.FC<MostActivesProps> = ({}) => {

    const [gainersData, setGainersData] = useState<any>({});
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
 
    useEffect(() => {
    handleGainers()
  }, []); 


  const fetchGainersFromApi = async () => {
    try {
      const result = await fetchData(`${host}/current-most-actives`);
      setGainersData(result);
    } catch (err) {
      setError('Failed to fetch gainers');
      console.log('err', err);
    } finally {
    
    }
  };

  const handleGainers = async () => {
    fetchGainersFromApi();
  };

  return (
  
     <div>

        <h3 className="avwapp-subtitle">
          Most Actives of the day (No biotechs)
        </h3>   
          {Object.keys(gainersData).map(function (ticker, index) {
            const chartObj = gainersData[ticker];
            return (
              <div className="stock">
                <ProfileRow profile={chartObj.profile} ticker={ticker} symbolInfo={chartObj.symbolInfo} />

                <div className="row">
                  <div className="column">
                    <p> 6 month daily, 21 SDMA</p>

                    <CanvasItem
                      width={500}
                      height={300}
                      index={index}
                      ticker={ticker}
                      matchViewportWidth={false}
                      title={'6 month daily'}
                      onPriceChange={price => {}}

                      chartData={chartObj.daily}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        
    </div>
  );
};





export default MostActives;